import { useGetBusinessUserMeQuery } from '@/pages/Business/pages/Users/services';
import type { Option } from '@/components/inputs/AutocompleteInput';
import { useMemo } from 'react';

const useScopedCommerces = () => {
  const { data: businessUserMe, isLoading } = useGetBusinessUserMeQuery();

  const commerceIds = useMemo(
    () => businessUserMe?.scopes?.commerce?.include ?? [],
    [businessUserMe]
  );

  const commerces = useMemo<Option[]>(() => {
    const resources = businessUserMe?.resources?.commerce ?? {};
    return commerceIds
      .map((id) => ({
        
        label: resources[id]?.name || resources[id]?.businessName || id,
        data: id,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
      );
  }, [businessUserMe, commerceIds]);

  return {
    commerces,
    commerceIds,
    singleCommerceId: commerceIds.length === 1 ? commerceIds[0] : null,
    isMulti: commerceIds.length > 1,
    isLoading,
  };
};

export default useScopedCommerces;
